import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Text } from '@olxbr/design-system'

import { fontSemiSmall } from '../../../util/font'

const _Text = ({ inverted, ...props }) => <Text {...props} /> // eslint-disable-line
const LinkText = styled(_Text)`
  font-size: 16px;
  flex-direction: row;
  color: ${props => (props.inverted ? '#f28000' : '#ffffff')};
`

const LINK = ({ inverted, ...props }) => <a {...props} /> // eslint-disable-line
const Anchor = styled(LINK)`
  width: ${props => props.width};
  height: ${props => props.height};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  background-color: ${props => (props.inverted ? '#ffffff' : '#f28000')};
  border-radius: 30px;
  ${fontSemiSmall};
  font-weight: 700;
  text-align: center;
  user-select: none;
  border: 1px solid ${props => (props.inverted ? '#f28000' : 'transparent')};
`

const LinkButton = props => {
  // eslint-disable-next-line
  const { href, width, height, inverted, renderIcon, text, onClick, ...rest } = props
  return (
    <Anchor href={href} width={width} height={height} inverted={inverted} onClick={onClick}>
      {renderIcon && renderIcon()}
      <LinkText inverted={inverted}>{text}</LinkText>
    </Anchor>
  )
}

LinkButton.propTypes = {
  renderIcon: PropTypes.func,
  text: PropTypes.string,
  href: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  inverted: PropTypes.bool,
}

LinkButton.defaultProps = {
  href: '#',
}

export default LinkButton
